//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import contactMentorsForm from '~/mixins/contactMentorsForm.js'

export default {
  mixins: [contactMentorsForm],
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    answers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formData: {
        tellmore: null,
      },
      invalidFields: {
        tellmore: false,
      },
    }
  },
  methods: {
    transformAnswersToOptions(answers) {
      const options = {}
      if (this.answers[1] && this.answers[1].length > 0) {
        this.answers[1].forEach((answer) => {
          options[answer] = answer
        })
      }
      return options
    },
    onRadioInput($event) {
      this.onInput('tellmore', $event)
      if (!this.inputHandled) {
        this.inputHandled = true
        this.onNext()
      }
    },
  },
}
